<template>
  <div>
    <ui-modal
      :alignTop="true"
      :alignTopMargin="20"
      :removeHeader="false"
      ref="modal"
      title="Detalle de tracking de booking"
      class="modal-tracking"
      size="auto"
      @close="ActionSetVisibleModalSinayTracking(false); ActionSetZindexTablaModal(false);">
      <ui-tabs
        v-if="iframeUrls.length"
        :key="tabsKey"
        fullwidth
        class="tracking-iframe-tabs">
        <ui-tab
          v-for="(iframeUrl, index) in iframeUrls"
          :id="String(index)"
          :key="iframeKey(iframeUrl, index)"
          :title="iframeTabTitle(iframeUrl, index)">
          <div style="width:100%; height:100vh; margin:0; padding:0;">
            <iframe
              :key="iframeKey(iframeUrl, index)"
              :src="iframeSrc(iframeUrl)"
              style="width:100%; height:100%; border:none;"
              allowfullscreen>
            </iframe>
          </div>
        </ui-tab>
      </ui-tabs>

      <div v-else class="text-center text-muted py-5">
        Sin tracking disponible
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
import { logTrackingModalDesktop } from "@/constants/lineas";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";

export default {
  components: { UiTabs, UiTab },
  props: {
    urls: {
      default: () => []
    },
    bookingNumber: {
      default: ""
    }
  },
  data() {

    return {

      data: [],
      renderKey: 0

    };

  },
  computed: {

    ...mapState(["visibleModalSinayTracking"]),

    ...mapState(["usuarioActual"]),

    iframeUrls() {

      if (Array.isArray(this.urls)) {

        return this.urls.filter(Boolean);

      }

      return this.urls ? [this.urls] : [];

    },

    tabsKey() {

      return `${this.renderKey}-${this.iframeUrls.map((iframeUrl, index) => this.iframeKey(iframeUrl, index)).join("|")}`;

    }

  },

  methods: {

    ...mapActions([
      "ActionSetVisibleModalSinayTracking",
      "ActionSetZindexTablaModal"
    ]),

    openModal(ref) {

      this.renderKey += 1;

      this.$refs[ref].open();

      this.ActionSetZindexTablaModal(true);

    },

    closeModal(ref) {

      this.$refs[ref].close();

    },

    iframeTabTitle(iframeUrl, index) {

      return (iframeUrl && iframeUrl.booking_number) || `Tracking ${index + 1}`;

    },

    iframeSrc(iframeUrl) {

      if (!iframeUrl) {

        return "";

      }

      if (typeof iframeUrl === "string") {

        return iframeUrl;

      }

      return iframeUrl.iframe_url || iframeUrl.url || "";

    },

    iframeKey(iframeUrl, index) {

      return `${index}-${this.iframeSrc(iframeUrl)}`;

    },

    isDesktop() {

      return typeof window !== "undefined" && window.matchMedia("(min-width: 768px)").matches;

    },

    logTrackingModalDesktop() {

      if (!this.isDesktop() || !this.bookingNumber) {

        return;
        
      }

      logTrackingModalDesktop({ booking_number: this.bookingNumber }).catch((error) => {

        console.warn("No se pudo registrar la apertura del modal de tracking.", error);

      });

    }

  },

  watch: {

    visibleModalSinayTracking(_new) {

      if (_new) {

        this.openModal("modal");

        this.logTrackingModalDesktop();

      }

    }

  }

};
</script>

<style>
.modal-tracking .ui-modal__container {
  width: 90% !important;
}
</style>
